import React, { useState, useEffect } from 'react';
import axiosInstance from '../../Services/axiosCommon';

const UseGetDataSearch = (url, params=null) => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [credit, setCredit] = useState(0);
  const [advance, setAdvance] = useState(0);
  const [dataLoading, setDataLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [pageAmount, setPageAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(0);



  async function getData() {
    setDataLoading(true);
    try {
      const res = await axiosInstance.get(url, { params });
      params?.page!=="" && params?.pageCount!==""? setData(res?.data?.data?.data || []) : setData(res?.data?.data || []) ;
      params?.page!=="" && params?.pageCount!=="" ? setTotalCount(res?.data?.data?.total || 0) : setTotalCount(0)
      res.data?.credit && setCredit(res.data?.credit)
      res.data?.advance && setAdvance(res.data?.advance)
      setTotal(res?.data?.data?.total || 0)
      setTotalAmount(res?.data?.data?.total_amount || 0)
      setPageAmount(res?.data?.data?.page_amount || 0)
      setDueAmount(res?.data?.data?.due_amount || 0)

      setDataLoading(false);
    } catch (error) {
      console.log(error);
      setDataLoading(false);
    }
  }
  useEffect(() => {
    getData();
  }, [url, JSON.stringify(params)]);

  return { data, totalCount,totalAmount,pageAmount,dueAmount , credit, advance, getData , dataLoading,total };
};

export default UseGetDataSearch;

// import React, { useState, useEffect } from 'react';
// import axiosInstance from '../../Services/axiosCommon';

// const CACHE_EXPIRY_TIME = 5 * 60 * 1000; // 5 minutes

// // utils
// const getCache = (key) => {
//   const cached = localStorage.getItem(key);
//   if (cached) {
//     const { data, expiry } = JSON.parse(cached);
//     if (Date.now() < expiry) {
//       return data;
//     } else {
//       localStorage.removeItem(key);
//     }
//   }
//   return null;
// };

// const setCache = (key, data) => {
//   const cacheObject = {
//     data,
//     expiry: Date.now() + CACHE_EXPIRY_TIME,
//   };
//   localStorage.setItem(key, JSON.stringify(cacheObject));
// };

// export const clearCache = (key) => {
//   localStorage.removeItem(key);
// };

// // Main hook
// const UseGetDataSearch = (url, params = null, cacheKey = null) => {
//   const [data, setData] = useState([]);
//   const [totalCount, setTotalCount] = useState(0);
//   const [credit, setCredit] = useState(0);
//   const [advance, setAdvance] = useState(0);
//   const [dataLoading, setDataLoading] = useState(true);
//   const [total, setTotal] = useState(0);

//   const getData = async () => {
//     setDataLoading(true);

//     try {
//       // Build dynamic cache key using page and per_page (or pageCount)
//       const page = params?.page || 1;
//       const per_page = params?.pageCount || 20;
//       const fullCacheKey = cacheKey ? `${cacheKey}_${page}_${per_page}` : null;

//       const cacheData = fullCacheKey ? getCache(fullCacheKey) : null;

//       if (cacheData) {
//         // Use cached data
//         setData(cacheData.data);
//         setTotalCount(cacheData.totalCount);
//         setCredit(cacheData.credit || 0);
//         setAdvance(cacheData.advance || 0);
//         setTotal(cacheData.total || 0);
//         setDataLoading(false);
//       } else {
//         // Fetch from API
//         const res = await axiosInstance.get(url, { params });
//         const responseData =
//           page !== '' && per_page !== ''
//             ? res?.data?.data?.data || []
//             : res?.data?.data || [];

//         setData(responseData);
//         setTotalCount(res?.data?.data?.total || 0);
//         setCredit(res.data?.credit || 0);
//         setAdvance(res.data?.advance || 0);
//         setTotal(res?.data?.data?.total || 0);

//         // Store in cache
//         if (fullCacheKey) {
//           setCache(fullCacheKey, {
//             data: responseData,
//             totalCount: res?.data?.data?.total || 0,
//             credit: res.data?.credit || 0,
//             advance: res.data?.advance || 0,
//             total: res?.data?.data?.total || 0,
//           });
//         }

//         setDataLoading(false);
//       }
//     } catch (error) {
//       console.error(error);
//       setDataLoading(false);
//     }
//   };

//   useEffect(() => {
//     getData();
//   }, [url, JSON.stringify(params)]);

//   return { data, totalCount, credit, advance, getData, dataLoading, total };
// };

// export default UseGetDataSearch;
